import React, { useContext, useEffect, useState } from "react";
import ReleaseItemSection from "../releaseItemCard";
import { getCurrentReleaseInfo } from "../../../services/releaseData";
import loaderContext from "../../../../../../context/loader/loaderContext";

const CurrentRelease = () => {

    const [currentRelease, setCurrentRelease] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { updateLoaderStatus } = useContext(loaderContext);

    useEffect(() => {

        const getData = async () => {
            setIsLoading(true);
            updateLoaderStatus(true);
            try {
                const response = await getCurrentReleaseInfo();

                if (response && response.length > 0) {

                    const releaseInfo = {
                        Id: response[0].Id,
                        VersionName: response[0].VersionName,
                        Title: response[0].Title,
                        Description: response[0].Description,
                        ReleaseDate: response[0].ReleaseDate
                    };

                    const items = response
                        .filter(x => x.ItemId !== null)
                        .map(x => ({
                            Id: x.ItemId,
                            Title: x.ItemTitle,
                            Description: x.ItemDescription,
                            ItemType: x.ItemType,
                            VideoUrl: x.VideoUrl
                        }));

                    setCurrentRelease({
                        ...releaseInfo,
                        items
                    });

                }
                // updateLoaderStatus(false);

            } catch (error) {
                console.error("Error loading current release:", error);
                // updateLoaderStatus(false);
            } finally {
                setIsLoading(false);
                updateLoaderStatus(false);
            }
        };

        getData();

    }, []);


    // if (!currentRelease) return null;
    const features = currentRelease?.items?.filter(i => i.ItemType === 1) || [];
    const improvements = currentRelease?.items?.filter(i => i.ItemType === 2) || [];
    const bugFixes = currentRelease?.items?.filter(i => i.ItemType === 3) || [];

    return (
        <div className="dashboard-wrapper">
            {(!currentRelease || currentRelease.length === 0) && !isLoading ? (
                <div className="upcoming-release-no-records">No Current Releases</div>) : (!currentRelease || currentRelease.length === 0) && isLoading ? (<div></div>) : (
                    <div className="release-container">

                        <div className="release-header">
                            <h1>{currentRelease.Title}</h1>
                            <h3>Version : {currentRelease.VersionName}</h3>
                            <p>{currentRelease.Description}</p>
                            <p className="release-date">
                                Release Date: {currentRelease.ReleaseDate}
                            </p>
                        </div>
                        <ReleaseItemSection title="✨ New Features" items={features} />
                        <ReleaseItemSection title="🚀 Improvements" items={improvements} />
                        <ReleaseItemSection title="🐞 Bug Fixes" items={bugFixes} />

                    </div>
                )}
        </div>
    );
};

export default CurrentRelease;